module.exports = __webpack_public_path__ + "files/4376f45e4563c694f88b2f9e8b1ea924.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lora-bolditalic-webfont.eot
// module id = 341
// module chunks = 60